import { Outlet } from 'react-router-dom';

import NavBar from './NavBar';

export default function MainLayout() {
  return (
    <div className="app flex flex-col h-screen bg-background">
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        <div className="w-full p-4 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
